module.exports = __webpack_public_path__ + "static/img/partner9.13ba405.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partner9.png
// module id = 6ZpL
// module chunks = 8